var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1924_148)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.811127 15H13.7892C14.2353 15 14.6003 14.4375 14.6003 13.75C14.6003 13.0625 14.2353 12.5 13.7892 12.5H0.811127C0.365007 12.5 0 13.0625 0 13.75C0 14.4375 0.365007 15 0.811127 15ZM0.811127 8.75H13.7892C14.2353 8.75 14.6003 8.1875 14.6003 7.5C14.6003 6.8125 14.2353 6.25 13.7892 6.25H0.811127C0.365007 6.25 0 6.8125 0 7.5C0 8.1875 0.365007 8.75 0.811127 8.75ZM0 1.25C0 1.9375 0.365007 2.5 0.811127 2.5H13.7892C14.2353 2.5 14.6003 1.9375 14.6003 1.25C14.6003 0.5625 14.2353 0 13.7892 0H0.811127C0.365007 0 0 0.5625 0 1.25Z",
    fill: "#1D1D1D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1924_148"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.6003,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCollapse);
export default __webpack_public_path__ + "static/media/IconCollapse.8a36cce46ffc480ca357e2ffabc8ce81.svg";
export { ForwardRef as ReactComponent };